'use client'

import React from 'react';
import { StyledDiv } from './affiliatesWhyPartner.styles';
import { Feature } from '../feature/feature.comp';

export const AffiliatesWhyPartner = () => {
    return (
        <StyledDiv>
            <h3>Why Should You Partner With Us?</h3>
            <Feature
                className='affiliates-feature'
                title='We have an Extensive Collection of Highly Sought-After Widgets'
                title2='We Constantly Release New Widgets'
                text2='Our list of widgets is ever-growing. We release at least one or two widgets per month, with some months having more than 10 widgets released. So you’ll have plenty of products to promote.'
                text='Our widgets work on any website! Whether the website is built on WordPress, Wix, WooCommerce, Shopify, BigCommerce, Duda, Squarespace, or any other platform — our widgets will work superbly.'
                position='ltr'
                img='/assets/affiliates-widget-collection.png'
                alt='widget collection'
            />
            <Feature
                title='We Provide You With a Creative Library of Assets'
                title2='We Provide Full Support'
                text2='Our affiliates receive full support for all things related to the affiliate program.'
                text='Should you become our affiliate, we’ll provide you with an extensive library of creative assets that you can use at your discretion to promote our products.'
                position='rtl'
                img='/assets/affiliates-assets.png'
                alt='assets library'
            />
        </StyledDiv>
    );
};

